// // // This file can be replaced during build by using the `fileReplacements` array.
// // // `ng build` replaces `environment.ts` with `environment.prod.ts`.
// // // The list of file replacements can be found in `angular.json`.

import { APISUBSCRIPTIONDEV, CLIENTIDDEV, LOCALHOSTCLIENTID, PASSVERIFYDEV, STORAGEDEV, TENANTIDDEV, URLDEV, URLDEVVERIFY, USERVERIFYDEV } from "src/app/utils/const/misc";

export const environment = {
  production: false,
  apiSubscriptionKey: `${APISUBSCRIPTIONDEV}`,

  menuBackend: `${URLDEV}/api/nit-bo-users/navigation/`,
  menuNewBackend: `${URLDEV}/api/nit-bo-users/nitro-menu-item/`,

  apiSubscriptionMenuKey: `${APISUBSCRIPTIONDEV}`,
  apiSubscriptionUploadKey: `${APISUBSCRIPTIONDEV}`,
  apiSubscriptionUserKey: `${APISUBSCRIPTIONDEV}`,
  apiSubscriptionUserSaveKey: `${APISUBSCRIPTIONDEV}`,
  apiSubscriptionUserUploadKey: `${APISUBSCRIPTIONDEV}`,
  apiSubscriptionDataPolicy: `${APISUBSCRIPTIONDEV}`,
  apiSubscriptionUserNitroReportKey: `${APISUBSCRIPTIONDEV}`,
  apiSubscriptionDexsKey: `${APISUBSCRIPTIONDEV}`,
  apiSubscriptionRole: `${APISUBSCRIPTIONDEV}`,
  apiSubscriptionRoutineForms: `${APISUBSCRIPTIONDEV}`,

  usersAppBackend: `${URLDEV}/api/nit-bo-users/user`,
  usersAllAppBackend: `${URLDEV}/api/nit-bo-users/users`,
  dataPolicyBackend: `${URLDEV}/api/nit-bo-uploader/dex-privacy-policy`,
  resetPasswordBackend: `${URLDEV}/api/nit-bo-users/reset-password`,
  reportUserNitroBackend: `${URLDEV}/api/nit-bo-users/user-sync/report`,
  surveysAppBackend: `${URLDEV}/api/nit-customer/nitro-survey`,
  dexsAppBackend: `${URLDEV}/api/nit-config/distributors`,
  rolesBackend: `${URLDEV}/api/nit-bo-users/role`,
  dataPolicyReportBackend: `${URLDEV}/api/nit-customer/policy-report`,
  routineFormsBackend: `${URLDEV}/api/nit-supervisor/forms`,
  usersBOAppBackend: `${URLDEV}/api/nit-bo-users/backoffice-users`,
  rolesBOBackend: `${URLDEV}/api/nit-bo-users/backoffice-role`,
  parametersBOBackend: `${URLDEV}/api/nit-bo-users/parameter`,
  verifyBackend: `${URLDEV}/api/nit-bo-users/verify`,
  menusBOBackend: `${URLDEV}/api/nit-bo-users/nitro-menu-item`,

  storageNitroAccount: {
    uploadBackend: `${URLDEV}/api/nit-bo-uploader/blobstorage/upload/`,
    uploadBackendNew: `${URLDEV}/api/nit-bo-uploader/blobstorage/upload/`,
    nitro: {
      accountName:  `${STORAGEDEV}`,
      containerName: 'backoffice',
      appContainerName: 'nitro-app-cdn',
    }
  },
  appName: 'nitro-bo-jwt-dev',
  baseUrl: {
    auth: `${URLDEV}/`,
  },
  azureAD: {
    client_id: `${CLIENTIDDEV}`,
    // client_id: 'ca2c2c29-7fa5-4edf-a906-f601dc52148c',
    tenant_id: `${TENANTIDDEV}`,
    scope: '',
  },
  verifyData: {
    user: `${USERVERIFYDEV}`,
    passoword: `${PASSVERIFYDEV}`
  }
};